import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { isEmpty } from 'lodash'
import apiPost from 'lib/network/apiPost'
import EmptyState from 'components/pageComponents/EmptyState'
import { FactsFields, Field, Notice, Panel, SimulationResult, btn, inputClass, isBlank, toFactsPayload, validateFacts } from './refundShared'

/** Read-only: POST refunds/simulate never moves money. */
const RefundSimulator = ({ settings }) => {
  const { t } = useTranslation()
  const [values, setValues] = useState(() => ({ cancelAt: moment().format('YYYY-MM-DDTHH:mm') }))
  const [errors, setErrors] = useState({})
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)

  const setValue = (key, value) => {
    setValues(prev => ({ ...prev, [key]: value }))
    setErrors(prev => ({ ...prev, [key]: undefined }))
  }

  const simulate = async e => {
    e.preventDefault()
    const nextErrors = { ...validateFacts(values, t), ...(isBlank(values.bookingId) ? { bookingId: t('refundEngine.common.required') } : {}) }
    setErrors(nextErrors)
    if (!isEmpty(nextErrors)) return
    setLoading(true)
    const response = await apiPost('refunds/simulate', toFactsPayload(values))
    setLoading(false)
    setResult(response?.success ? response.data : null)
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
      <Panel>
        <form onSubmit={simulate} noValidate className="space-y-4">
          <Notice type="warning" title={t('refundEngine.simulator.readOnly')} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field label={t('refundEngine.simulator.bookingId')} htmlFor="sim-booking" error={errors.bookingId}>
              <input id="sim-booking" value={values.bookingId || ''} onChange={e => setValue('bookingId', e.target.value)} className={inputClass(errors.bookingId)} />
            </Field>
            <Field label={t('refundEngine.simulator.cancelAt')} htmlFor="sim-cancel-at">
              <input id="sim-cancel-at" type="datetime-local" value={values.cancelAt || ''} onChange={e => setValue('cancelAt', e.target.value)} className={inputClass()} />
            </Field>
          </div>
          <FactsFields settings={settings} values={values} errors={errors} onChange={setValue} />
          <div className="flex justify-end pt-4 border-t border-gray-100">
            <button type="submit" className={btn('primary')} disabled={loading}>
              {loading ? t('common.loading') : t('refundEngine.simulator.run')}
            </button>
          </div>
        </form>
      </Panel>
      {result ? (
        <SimulationResult result={result} />
      ) : (
        <div className="rounded-lg border border-dashed border-gray-300 bg-white">
          <EmptyState v2 description={t('refundEngine.simulator.run')} />
        </div>
      )}
    </div>
  )
}

export default RefundSimulator
